import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "eye--sprite",
  "use": "eye--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"eye--sprite\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 18a9.004 9.004 0 01-8.488-6.002 9.004 9.004 0 0116.976.004A9.004 9.004 0 0112 18zm0-13c4.477 0 8.268 2.944 9.542 7.002C20.267 16.058 16.477 19 12 19c-4.478 0-8.269-2.944-9.542-7.002C3.732 7.942 7.522 5 11.999 5zm2 7a2 2 0 11-4 0 2 2 0 014 0zm1 0a3 3 0 11-6 0 3 3 0 016 0z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol